// PrivateRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/auth-context';
import { saveRedirectIntent } from '../utils/redirect-intent';


const PrivateRoute = () => {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (currentUser === null) {
    // Save redirect intent to localStorage before redirecting
    saveRedirectIntent(location.pathname);
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default PrivateRoute;